import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body scroll-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: ['options-quote-modal', $setup.props.isModalFiltersHousesHidden ? 'hidden' : '']
  }, {
    content: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("div", { class: "modal-title" }, "Filter home designs"),
        _createElementVNode("div", { class: "line" })
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["FilterHouses"], {
          result: $setup.props.result,
          lotSelected: $setup.props.lotSelected,
          quote: $setup.props.quote,
          houseDetailsView: $setup.props.houseDetailsView,
          isDesignModal: true,
          hasToLoadNextBatch: $setup.props.hasToLoadNextBatch,
          onHousesByFilter: $setup.onHousesByFilter,
          onUpdateHousesPagination: $setup.onUpdateHousesPagination
        }, null, 8, ["result", "lotSelected", "quote", "houseDetailsView", "hasToLoadNextBatch"]),
        _createElementVNode("div", { class: "content-button-search" }, [
          _createElementVNode("button", {
            class: "button default primary search",
            onClick: $setup.onSearch
          }, "Search")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "classes"]))
}